<template>
  <div >
      <div class="form-horizontal form-simple">
        <div class="row">
          <fieldset class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.user.$error }" >
            <input type="text" v-model.trim="$v.dataRegistr.user.$model"  class="form-control " id="user-name" :placeholder="$t('users.table.login')" >
            <div class="form-control-position">
                <i class="icon-head"></i>
            </div>
            <div class="error" v-if="!$v.dataRegistr.user.required">{{$t('errors.required')}}</div>
            <div class="error" v-if="!$v.dataRegistr.user.minLength">{{$t('errors.minLength')}} {{$v.dataRegistr.user.$params.minLength.min}} </div>
          </fieldset>        
        </div>
        <div class="row">
          <fieldset class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.password.$error }">
            <input type="password" v-model.trim="$v.dataRegistr.password.$model" class="form-control " id="user-password" :placeholder="$t('login.lbl.password')">
            <div class="form-control-position">
                <i class="icon-key3"></i>
            </div>
            <div class="error" v-if="!$v.dataRegistr.password.required">{{$t('errors.required')}}</div>
            <div class="error" v-if="!$v.dataRegistr.password.minLength">{{$t('errors.minLength')}} {{$v.dataRegistr.password.$params.minLength.min}} </div>
          </fieldset>
          <fieldset  class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.password2.$error }">
              <input type="password" v-model.trim="$v.dataRegistr.password2.$model"  class="form-control " id="user-password2" :placeholder="$t('registr.lbl.confirmPass')">
              <div class="form-control-position">
                  <i class="icon-key3"></i>
              </div>
              <div class="error" v-if="!$v.dataRegistr.password2.required">{{$t('errors.required')}}</div>
              
          </fieldset>
        </div>
        <div class="row">
            <fieldset class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.email.$error }">
              <input type="text" v-model.trim="$v.dataRegistr.email.$model" class="form-control " :placeholder="$t('registr.lbl.email')">
              <div class="form-control-position">
                  <i class="icon-email"></i>
              </div>
              <div class="error" v-if="!$v.dataRegistr.email.required">{{$t('errors.required')}}</div>
              <div class="error" v-if="!$v.dataRegistr.email.email">{{$t('errors.email')}}</div>
          </fieldset>
          <fieldset  class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.phone.$error }">
              <input type="text" id="contact" v-mask="'(###) ##-##-###'" class="form-control " :placeholder="$t('users.table.phone')" v-model.trim="$v.dataRegistr.phone.$model">
              <div class="form-control-position">
                <i class="icon-address-book" ></i>
            </div>
            <div class="error" v-if="!$v.dataRegistr.phone.required">{{$t('errors.required')}}</div>
          </fieldset>
        </div>
        <div class="row">
            <fieldset  class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" >           
                <input type="text" id="edrpo" v-mask="'############'" autocomplete="off" class="form-control " :placeholder=" $t('registr.lbl.edrpo')" @change="findClient()"  v-model.trim="dataRegistr.edrpo" >
              <div class="form-control-position">
                <!--<button type="button" class="btn btn-auth btn-sm" @click="findClient()"><i class="icon-search4" ></i></button>-->
                <a @click="findClient()"><i class="icon-search4" ></i></a>
              </div>            
           </fieldset>
            <fieldset  class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" > 
                <input type="text" id="ipn" v-mask="'############'" autocomplete="off" class="form-control " :placeholder=" $t('registr.lbl.ipn')" @change="findClient()" v-model.trim="dataRegistr.ipn" >
              <div class="form-control-position">
                <!--<button type="button" class="btn btn-auth btn-sm" @click="findClient()"><i class="icon-search4" ></i></button>-->
                <a @click="findClient()"><i class="icon-search4" ></i></a>
              </div>                          
          </fieldset>
        </div>
        <div class="row">
          <fieldset  class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.username.$error }">
            <input type="text" v-model.trim="$v.dataRegistr.username.$model" class="form-control " :placeholder="$t('registr.lbl.pib') " >
            <div class="form-control-position">
                <i class="icon-head"></i>
            </div>
            <div class="error" v-if="!$v.dataRegistr.username.required">{{$t('errors.required')}}</div>
        </fieldset>
        <fieldset  class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.nameClient.$error }">
            <input type="text" v-model.trim="$v.dataRegistr.nameClient.$model" class="form-control " :placeholder=" $t('registr.lbl.organization')">
            <div class="form-control-position">
                <i class="icon-bank"></i>
            </div>
            <div class="error" v-if="!$v.dataRegistr.nameClient.required">{{$t('errors.required')}}</div>
        </fieldset>
        </div>        
        <div v-if="dataRegistr.newClient">
          <div class="row">
              <fieldset class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.urAdress.$error }">
                <input type="text" v-model.trim="$v.dataRegistr.urAdress.$model" class="form-control " :placeholder="$t('registr.lbl.urAdress')">
                <div class="form-control-position">
                    <i class="icon-tag"></i>
                </div>
                <div class="error" v-if="!$v.dataRegistr.urAdress.required">{{$t('errors.required')}}</div>                                
            </fieldset>
             <fieldset class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.mfo.$error }">
                <input type="text" v-model.trim="$v.dataRegistr.mfo.$model" class="form-control " :placeholder="$t('registr.lbl.mfo')">
                <div class="form-control-position">
                    <i class="icon-tag"></i>
                </div>
                <div class="error" v-if="!$v.dataRegistr.mfo.required">{{$t('errors.required')}}</div>                                
            </fieldset>
          </div>
          <div class="row">
            <fieldset class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.signatoryOfDocuments.$error }">
                <input type="text" v-model.trim="$v.dataRegistr.signatoryOfDocuments.$model" class="form-control " :placeholder="$t('registr.lbl.signatoryOfDocuments')">
                <div class="form-control-position">
                    <i class="icon-tag"></i>
                </div>
                <div class="error" v-if="!$v.dataRegistr.signatoryOfDocuments.required">{{$t('errors.required')}}</div>                                
            </fieldset>
            <fieldset class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.iban.$error }">
                <input type="text" v-model.trim="$v.dataRegistr.iban.$model" class="form-control " :placeholder="$t('registr.lbl.iban')">
                <div class="form-control-position">
                    <i class="icon-tag"></i>
                </div>
                <div class="error" v-if="!$v.dataRegistr.iban.required">{{$t('errors.required')}}</div>                                
            </fieldset>
          </div>
          <div class="row">
            <fieldset class="form-group col-md-6 col-xs-12 position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.companyDocuments.$error }">
                <textarea type="text" v-model.trim="$v.dataRegistr.companyDocuments.$model" class="form-control " :placeholder="$t('registr.lbl.companyDocuments')"></textarea>
                <div class="form-control-position">
                    <i class="icon-tag"></i>
                </div>
                
                <div class="error" v-if="!$v.dataRegistr.companyDocuments.required">{{$t('errors.required')}}</div>                                
            </fieldset>
            
          </div>
          
        </div>
        <div class="row">
              <fieldset class="col-md-6 col-xs-12"  :class="{ 'form-group--error': $v.dataRegistr.pdv.$error }">
                  <div class="form-group " >
                    <label class="text-bold-600" for="issueinput5">{{$t('tender.label.PDV')}}</label>
                    <select v-model="dataRegistr.pdv" id="issueinput5" name="priority" class="form-control" data-toggle="tooltip" data-trigger="hover" data-placement="top" data-title="Priority" data-original-title="" title="">
                        <option value=null selected ></option>
                        <option value=true>{{$t('registr.lbl.yes')}}</option>
                        <option value=false>{{$t('registr.lbl.no')}}</option>                               
                    </select>
                  </div>
                  <div class="error" v-if="!$v.dataRegistr.pdv.required">{{$t('errors.required')}}</div>
                </fieldset>
          </div>
        <div class="row">
          <div class="form-group col-md-6 col-xs-12">
              <fieldset  class="form-group position-relative checkboxsas mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.typeOfdelivery.$error }">
                <label class="text-bold-600"> {{$t('tender.label.trType')}} </label>  
              </fieldset>
              
              <fieldset  class="form-group position-relative checkboxsas mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.typeOfdelivery.$error }">  
                                        
                <label>
                  <input type="checkbox" value="true" v-model="dataRegistr.typeOfdelivery.auto">
                  {{$t('tender.trType.1')}}
                </label> 
                <label>
                  <input type="checkbox" value="true" v-model="dataRegistr.typeOfdelivery.jd">
                  {{$t('tender.trType.3')}}
                </label>   
                <label>
                  <input type="checkbox" value="true" v-model="dataRegistr.typeOfdelivery.avia">
                  {{$t('tender.trType.2')}}
                </label>                      
                <label>
                  <input type="checkbox" value="true" v-model="dataRegistr.typeOfdelivery.sea">
                  {{$t('tender.trType.4')}}
                </label>  
                <div class="error" v-if="!$v.dataRegistr.typeOfdelivery.notEmpty">{{$t('errors.required')}}</div>                    
              </fieldset>
          </div>
          <div class="form-group col-md-6 col-xs-12">
              <fieldset  class="form-group position-relative checkboxsas mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.directionOfdelivery.$error }" >
                  <label class="text-bold-600"> {{$t('tender.label.trDirection')}} </label>  
                </fieldset>
                  <fieldset  class="form-group position-relative checkboxsas mb-otstup" :class="{ 'form-group--error': $v.dataRegistr.directionOfdelivery.$error }">                                                       
                  <label>
                    <input type="checkbox" value="1" v-model="dataRegistr.directionOfdelivery.internal">
                      {{$t('tender.direction.1')}}
                  </label> 
                  <label>
                    <input type="checkbox" value="2" v-model="dataRegistr.directionOfdelivery.exsternal">
                    {{$t('tender.direction.2')}}
                  </label>
                  <div class="error" v-if="!$v.dataRegistr.directionOfdelivery.notEmptyDirection">{{$t('errors.required')}}</div>          
                </fieldset>
          </div>
        </div>
        <div class="row" >             
              <fieldset class="col-md-12 col-xs-12" :class="{ 'form-group--error': $v.dataRegistr.policy.$error }" >               
                  <div class="form-group " >
                    <div class="policy-item">
                      <label>
                        <input type="checkbox" value="true" v-model="$v.dataRegistr.policy.$model" >
                        <span class="link" @click="$modal.show('policy')">{{$t('registr.lbl.police')}} </span>
                        
                      </label>                      
                    </div>
                  </div>
                  
              </fieldset>
              <fieldset class="col-md-12 col-xs-12" :class="{ 'form-group--error': $v.dataRegistr.gdr.$error }" >               
                  <div class="form-group " >
                    <div class="policy-item">
                      <label>
                        <input type="checkbox" value="true" v-model="$v.dataRegistr.gdr.$model" >
                        <span>{{$t('registr.lbl.gdr')}} </span>
                        
                      </label>                      
                    </div>
                  </div>
                  
              </fieldset>
              <fieldset class="col-md-12 col-xs-12"  >               
                  <div class="form-group " >
                    <div class="policy-item">
                      <label>                       
                        <a class="link" target="_blank" href="/dist/dogovir_res.docx"><span  >{{$t('registr.lbl.dogovirRes')}} <i class="icon-inbox2"></i> </span>  </a>                      
                      </label>                      
                    </div>
                  </div>                  
              </fieldset>
              <fieldset class="col-md-12 col-xs-12"  >               
                  <div class="form-group " >
                    <div class="policy-item">
                      <label>                       
                        <a class="link" target="_blank" href="/dist/dogovir_not_res.docx"><span  >{{$t('registr.lbl.dogovirNotRes')}} <i class="icon-inbox2"></i> </span>  </a>                      
                      </label>                      
                    </div>
                  </div>                  
              </fieldset>
              
          </div>
      
         <div class="mb-2">
           <div class="rcapcha " :class="!this.rKey && !this.rcapchaError ? 'cliar' : 'rcapcha-error'" >
              <vue-recaptcha ref="recaptcha"   @expired="onCaptchaExpired" @verify="verifyRecaptcha" sitekey="6LeF_YAfAAAAAClSUjqkIZAz09J2fEXvykFaZxah">                                     
              </vue-recaptcha>
          </div>
         </div>
        

        <fieldset  class="form-group position-relative has-icon-left">                                
            <input type="file" name="file" id="file" class="inputfile" multiple @change="onUploadImg"/>
            <center>
              <label>{{$t('registr.lbl.loadFiles')}}</label>
              <label id="file_loader" for="file"><a class="btn btn-warning btn-min-width">
                <i class="icon-upload3"></i> {{ $t('tasks.buttons.file') }}</a>
              </label>
            </center>
        </fieldset>
    
        <div class="mb-2" v-if="files.length" >
            <div style="display: flex; justify-content: start;">
                <div 
                  v-for="(file, key) in files" 
                  v-bind:key="'file-'+key"
                  class="file-listing">{{ file.name }} <span class="remove-file" v-on:click="removeFile( key )"><i class="icon-cross ml-1"></i></span>
              </div>
            </div>
        </div>      
        
      </div>
      <div class="row">
        
      </div>
      <div class="row">
        <div class="d-flex align-items-center justify-content-center">
          
            <div class="col-md-8">
              <button  type="button" class="btn btn-auth btn-lg btn-block"  @click="register()"><i class="icon-unlock2"></i> {{ $t('registr.btn.reg') }}</button>
            </div>            
        </div>
      </div>
      <!-- Modal select-winner -->
        <modal name="policy" 
        :min-width="200"    
        :min-height="200"
        :scrollable="true"    
        :reset="true"
        width="60%" 
        height="auto">
         <div class="card policy">
             <div class="card-header" style="border-radius: 0.27rem">
                <h4 class="card-title">{{$t('registr.police.title')}}</h4>
                <div class="heading-elements">
                    <button type="button" id="closeBtn" ref="closeModalEq" class="btn btn-warning" data-dismiss="modal" @click="$modal.hide('policy')">
                        <!--<span aria-hidden="true">&times;</span>-->
                        <i class="icon-cross" style="color: white"></i>
                    </button>
                </div>
            </div>
             <div class="card-body p-1">
                  <p><b>{{$t('registr.police.body.p1s')}}</b> {{$t('registr.police.body.p1')}}</p>
                  <p><b>{{$t('registr.police.body.p2s')}}</b> {{$t('registr.police.body.p2')}}</p>
                  <p><b>{{$t('registr.police.body.p3s')}}</b> {{$t('registr.police.body.p3')}}</p>
                  <p><b>{{$t('registr.police.body.p4s')}}</b> {{$t('registr.police.body.p4')}}</p>
                

             </div>         
        </div>
         <!--  // and card -->           
    </modal>
    <!-- And modal select-winner -->
  </div>
    
</template>

<script>
import { required, minLength,  sameAs, email, requiredIf, helpers  } from 'vuelidate/lib/validators'
const notEmpty = (val) =>{ return val.auto || val.avia || val.jd || val.sea}
const notEmptyDirection = (val) =>{ return val.internal || val.exsternal}
import { VueRecaptcha } from 'vue-recaptcha';
export default {
  name: "regisretAsDelivery",
   components: {   
      VueRecaptcha      
        },
  props: {
    type: {
      type:String,
      default:"1"
    }
  },
  data() {
    return {
      rKey:null,
      rcapchaError:false,
      dataRegistr: {
          newClient:false, 
          user: null,
          password: null,
          password2: null,
          username: null,
          role: '',
          phone: null,
          email: null,
          edrpo: null,
          ipn:null,
          mfo:null,
          nameClient: null,
          guidClient: null,
          logo_organization: null,
          type: "1",
          pdv:null,
          companyName:"",
          urAdress:"",         
          iban:"",
          companyDocuments:"",
          signatoryOfDocuments:"",
          typeOfdelivery:{
            auto:false,
            jd:false,
            avia:false,
            sea:false
          },
          directionOfdelivery:{
            internal:false,
            exsternal:false
          },
          policy:null,
          gdr:null
          
        },       
        files: [],

        submitStatus:null,
    }
  },
  validations() {      
        if (this.dataRegistr.newClient) {
            return {
              dataRegistr:{
              newClient:{
                required
              },
                user:{
                    required,
                    minLength: minLength(4)
                },
                password:{
                    required,
                    minLength: minLength(8)
                },
              password2:{            
                required,
                minLength: minLength(8)            
              },
              email:{
                required,
                email            
              },
              username:{
                required                       
              },
              phone:{
                required                       
              },
              edrpo:{
                required                       
              },
              mfo:{
                required                       
              },
              nameClient:{
                required                       
              },              
              pdv:{
                required 
              },             
              urAdress:{
                required 
              },             
              iban:{
                required 
              },
              companyDocuments:{
                required 
              },
              signatoryOfDocuments:{
                required 
              },
              policy:{
                 required 
              },
              gdr:{
                 required 
              },
              
              
          directionOfdelivery:{
            notEmptyDirection
          },
          typeOfdelivery:{
            notEmpty
          }
                      
            },            
            }
        }      
        else return {
          dataRegistr:{
          newClient:{
            required
          },
            user:{
                required,
                minLength: minLength(4)
            },
            password:{
                required,
                minLength: minLength(8)
            },
          password2:{            
            required,
            minLength: minLength(8)            
          },
          email:{
            required,
            email            
          },
          username:{
            required                       
          },
          phone:{
            required                       
          },          
          nameClient:{
            required                       
          },
          pdv:{
                required 
              },         
          directionOfdelivery:{
            notEmptyDirection
          },
          typeOfdelivery:{
            // required
            notEmpty
            
          },
          policy:{
                 required 
              },
          gdr:{
                 required 
              },
        },
       
        }
      
  },
  computed: {
  
  },
  methods: {
    register(){
      this.$v.$touch()
      if (!this.rKey)  {
          this.rcapchaError = true
          return
      }
       if (this.$v.$invalid || !this.rKey ) {
          this.submitStatus = 'ERROR'
      }
      else {
        let dataRequest = {
          //userGuid: "",
          username: this.dataRegistr.username,
          login: this.dataRegistr.user,
          password: this.dataRegistr.password,
          email: this.dataRegistr.email,
          edrpo: this.dataRegistr.edrpo,
          inn : this.dataRegistr.ipn,
          mfo : this.dataRegistr.mfo,
          guidClient: this.dataRegistr.guidClient,
          nameClient: this.dataRegistr.nameClient,
          companyName: this.dataRegistr.companyName,
          urAdress: this.dataRegistr.urAdress,         
          iban: this.dataRegistr.iban,
          companyDocuments: this.dataRegistr.companyDocuments,
          signatoryOfDocuments: this.dataRegistr.signatoryOfDocuments,
          tel: this.dataRegistr.phone,
          type: this.dataRegistr.type,
          Novat: this.dataRegistr.pdv || false,
          role: this.dataRegistr.role,
          photo: null,
          typeOfdelivery:this.dataRegistr.typeOfdelivery,
          directionOfdelivery:this.dataRegistr.directionOfdelivery,
          files:this.files,
          token: this.rKey,
          system: "1"
        };     
          if (this.registerAsClient) {
            dataRequest.role = "clientME" 
          }
          // console.log("rigister")
          this.makeRequest("/portal/registrationUserTender", {dataRequest: dataRequest})
            .then(res => {
                if(res != null && res.data.result){
                  this.showNotification('custom-success','Registration','Successfully registered ');
                  this.$router.push({name: 'login'})
                }
                else {
                  this.showNotification('custom-info','Registration',res.data.data);
                }
            }); 
      }
    },
    findClient(){
            if ( this.isValid(this.dataRegistr.edrpo) || this.isValid(this.dataRegistr.ipn)){
              let dataRequest = {
                edrpo : this.dataRegistr.edrpo,
                inn : this.dataRegistr.ipn
              }; 
              if (dataRequest.edrpo || dataRequest.inn){
                this.makeRequest("/service/getClient", {dataRequest: dataRequest})
                .then(result => {
                  if (result.data.data.name.length){
                      this.dataRegistr.guidClient = result.data.data.guidClient;
                      this.dataRegistr.nameClient = result.data.data.name;
                  }
                  else {
                    this.showNotification('custom-info','Search','Client not found!');
                    this.dataRegistr.newClient = true
                    this.dataRegistr.type = "2"
                  }                  
                });

              }
            }
          },
          verifyRecaptcha(data){
            this.rKey = data;            
        },
        onCaptchaExpired () {
            // console.log("onCaptchaExpired");
            this.$refs.recaptcha.reset()
            this.rKey = null;
        },
        getCaptchaToken (){
         return  this.$refs.recaptcha.execute()
        },
          onUploadImg(e){
            console.log("start upload");           
            if (e.target.files.length > 0){
              for (let i = 0; i < e.target.files.length; i++) {
                const element = e.target.files[i];
                const reader = new FileReader();
                reader.readAsDataURL(element);
                reader.onload = e => {                 
                  this.files.push({name: element.name, data: e.target.result.split(',')[1]});                  
                };                        
              }
            }
          },
          removeFile( key ){
            this.files.splice( key, 1 );
          }
  },
   watch: {
           
        },
};
</script>

<style scoped>
.img_cont{
  max-width: 60%;
}
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
#file_loader {
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
	cursor: pointer;
}
 .form-group__message, .error {
    font-size: 0.75rem;
    line-height: 1;
    display: none;
    /* margin-left: 14px; */
    margin-top: 0.6875rem;
    margin-bottom: 0.9375rem; }
.form-group--alert,
  .form-group--error {
    animation-name: shakeError;
    animation-fill-mode: forwards;
    animation-duration: .6s;
    animation-timing-function: ease-in-out; }
  
    .form-group--success .form__label, .form-group--success .form__label--inline {
    color: #43AC6A; }
  
  .form-group--success .form-group__addon {
    color: white;
    border-color: #85d0a1;
    background: #85d0a1; }
  
  .form-group--success input,
  .form-group--success textarea,
  .form-group--success input:focus,
  .form-group--success input:hover {
    border-color: #85d0a1; }
  
  .form-group--success + .form-group__message, .form-group--success + .error {
    display: block;
    color: #73c893; }
  
  .form-group--error .form__label, .form-group--error .form__label--inline, .form-group--error .label{
    color: #f04124; 
    display: block;
    }
  
  .form-group--error .form-group__addon {
    color: white;
    border-color: #f79483;
    background: #f79483; }
  
  .form-group--error input,
  .form-group--error textarea,
  .form-group--error input:focus,
  .form-group--error input:hover {
    border-color: #f79483; }
  
  .form-group--error  .form-group__message, .form-group--error  .error  {
    display: block;
    color: #f57f6c; }
    .form-group--error label {    
    color: #f57f6c; }
  
  .form-group--alert .form__label, .form-group--alert .form__label--inline {
    color: #f08a24; }
  
  .form-group--alert .form-group__addon {
    color: white;
    border-color: #f7bd83;
    background: #f7bd83; }
  
  .form-group--alert input,
  .form-group--alert textarea,
  .form-group--alert input:focus,
  .form-group--alert input:hover {
    border-color: #f7bd83; }
  
  .form-group--alert + .form-group__message {
    display: block;
    color: #f5b06c; }
 
.edprou {
  padding-left: 0px;
  padding-right:5px ;
  padding-bottom: 5px;
}
.inn {
  padding-left: 5px;
  padding-right: 0px ;
}
.comment {
  width: 200px;
}
.card-block {
  padding: 10px;
}
.form-control, .form-control-lg {
font-size: 1rem !important;
}
.company-policy {
  font-weight: bold;
  margin-left: 15px;
  margin-bottom: 10px;
}
.policy-item {
  font-style:italic;
}
.submit-wrap {  
  display: block;
}
div.file-listing{
		
		margin: auto;
	}
span.remove-file{
  color: red;
  cursor: pointer;
  float: right;
  margin-top: -10px;
}
.rcapcha {
     width:fit-content ;
     
 }
 .rcapcha-error {
    border: 1px solid #f04124;
 }
.policy h4 {
  text-transform: none;
}
.link {
  color: #8CD2E8;
  cursor: pointer;
}
.link:hover {
  color: #0cb1e3;
  
}
@media only screen and (max-width: 800px) {
.inn {
   padding-left: 0px;
}
.ex-btn {
  display: block;
}
}
</style>


// WEBPACK FOOTER //
// src/components/forms/registerAsDelivery.vue